import type { AgreementsPayload } from '../models/agreements.model';
import {
    REPORT_RECORD_COUNT_ALLOWED_NUMBERS,
    REPORT_RECORD_COUNT_ELEMENT_ID,
} from '../report-record-count.constants';

export function validateAgreementsFilterRequest(
    payload: AgreementsPayload
): { ok: true } | { ok: false; message: string; invalidElementIds: readonly string[] } {
    const filter = payload.data?.filter;
    if (!filter) {
        return { ok: true };
    }

    const rc = filter.recordCount;
    if (rc !== undefined && !REPORT_RECORD_COUNT_ALLOWED_NUMBERS.includes(rc)) {
        return {
            ok: false,
            message: 'Record count must be one of the allowed values.',
            invalidElementIds: [REPORT_RECORD_COUNT_ELEMENT_ID],
        };
    }

    return { ok: true };
}
